import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * The app's toast surface.
 *
 * Styling lives in `styles.css` rather than in `toastOptions.classNames`, because
 * a class here applies to every toast equally and so flattens the one thing a
 * toast has to communicate: which of the four levels it is. The stylesheet keys
 * off Sonner's own `data-type`, so `success` can look like success.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return <Sonner className="toaster group" {...props} />;
};

export { Toaster };
